import React, { useContext } from "react";

import { GeoField } from "@/src/components/form-fields/GeoField";

import PlanDrawerContainerContext, {
  PLAN_DRAWER_POPOVER_CLASS,
} from "../plan-drawer-context";

import type { JSX } from "react";

interface PlanGeoFieldProps {
  disabled?: boolean;
}

function PlanGeoField({ disabled }: PlanGeoFieldProps): JSX.Element {
  const portalContainer = useContext(PlanDrawerContainerContext);

  return (
    <GeoField
      disabled={disabled}
      popoverClassName={PLAN_DRAWER_POPOVER_CLASS}
      popoverContainer={portalContainer}
    />
  );
}

export default PlanGeoField;
